module.exports = __webpack_public_path__ + "static/img/Brees-Yard-King.fbae8f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Brees-Yard-King.jpg
// module id = UOp5
// module chunks = 1